module.exports = __webpack_public_path__ + "static/katsuhisa__-5eb6518ca30e679df2dc6a54e78ca0cd.jpg";